import { message } from "antd/es";


const handleMessages = (data, param = "response") => {
  if (!data.success) {
    message.error(data.error?.errors?.[param] || data.error?.[param]);
    return false;
  } else if (data.data.message === "No iniciado") {
    message.error(data.data.response);
    return false;
  } else {
    message.success(data.data.response);
    return true;
  }
};

export default handleMessages;
